// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NatalChartPage_container__8rT2- {
  padding: 24px 16px 100px;
  max-width: 500px;
  margin: 0 auto;
  color: white;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.NatalChartPage_title__yBNE0 {
  font-size: 24px;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 30px;
}

.NatalChartPage_description__MjuML {
  font-size: 15px;
  color: #f0f0f0;
  line-height: 1.65;
  background: rgba(255, 255, 255, 0.05);
  padding: 16px;
  border-radius: 14px;
  backdrop-filter: blur(4px);
  white-space: pre-line;
  text-align: left;
  margin: 22px 0;
}

.NatalChartPage_buttons__h7tEC {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin: 20px 0;
}

.NatalChartPage_circle__a\\+1wn {
  border-radius: 50%;
  width: 100%;
  max-width: 420px;
  background: black;
}

.NatalChartPage_circle__a\\+1wn img {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/pages/NatalChartPage/NatalChartPage.module.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb","sourcesContent":[".container {\n  padding: 24px 16px 100px;\n  max-width: 500px;\n  margin: 0 auto;\n  color: white;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.title {\n  font-size: 24px;\n  font-weight: 700;\n  color: #ffffff;\n  margin-bottom: 30px;\n}\n\n.description {\n  font-size: 15px;\n  color: #f0f0f0;\n  line-height: 1.65;\n  background: rgba(255, 255, 255, 0.05);\n  padding: 16px;\n  border-radius: 14px;\n  backdrop-filter: blur(4px);\n  white-space: pre-line;\n  text-align: left;\n  margin: 22px 0;\n}\n\n.buttons {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  margin: 20px 0;\n}\n\n.circle {\n  border-radius: 50%;\n  width: 100%;\n  max-width: 420px;\n  background: black;\n}\n\n.circle img {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `NatalChartPage_container__8rT2-`,
	"title": `NatalChartPage_title__yBNE0`,
	"description": `NatalChartPage_description__MjuML`,
	"buttons": `NatalChartPage_buttons__h7tEC`,
	"circle": `NatalChartPage_circle__a+1wn`
};
export default ___CSS_LOADER_EXPORT___;
